module.exports = "<app-personal-description *ngFor=\"let personal of itemsFormArray.controls; let i=index\" [index]=\"i\" [personal]=\"personal\"\n    (removed)=\"itemsFormArray.removeAt($event)\" (notify)='onNotify($event)'>\n</app-personal-description>\n\n<h6><span *ngIf=\"exceed\" class=\"exceed_warning\">Careful, your resume might exceed a page!</span></h6>\n\n<button type=\"button\" class=\"btn btn-outline-info btn-sm float-right\" (click)=\"addItem()\">I have another skill or interest</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/personal/personal.component.html
// module id = ./src/app/main/content/personal/personal.component.html
// module chunks = main